export const environment = {
     production:false,
     NODE_ENV:"qa",
     BASE_URL:"",
     APP_API_URL:"https://www.qa.psp.tylerapp.com/PspApi",
     APP_CDB_URL:"https://cdb-uat.cdc.nicusa.com/dot/cust-admin/login.html",
     APP_PSP_BASE_URL:"https://www.qa.psp.tylerapp.com",
     APP_PSP_DOC_BASE_URL:"https://www.qa.psp.tylerapp.com/PspApi/Documents",
     APP_PSP_CDB_URL:"https://cdb-uat.cdc.nicusa.com/dot/",
     APP_PSP_NEXT_URL:"https://www.qa.psp.tylerapp.com/PspAdmin/",
     OUTPUT_DIR:"dist/",
     APP_GA4_MEASUREMENT_ID : "G-4DF3H4QXP5",
     APP_DRIVER_RECORD_EXPIRATION_HOURS:"120",
     APP_LOGIN_GOV_CLIENT_ID:"urn:gov:gsa:openidconnect.profiles:sp:sso:dot:psp",
     APP_LOGIN_GOV_LOGOFF_URL:"https://idp.int.identitysandbox.gov/openid_connect/logout"
};